import React from "react";
import { HowToCopy } from "../../how_tos/how_to_copy/how_to_copy.jsx";
import {
  Pricing,
  PricingPanel,
  PricingMessage,
} from "../../pricing/pricing.jsx";

export const Copying = ({ location }) => {
  return (
    <article>
      <HowToCopy />
      <br />
      <br />
      {"COPY" in location.pricing ? (
        <Pricing type="Copy">
          <PricingPanel
            pricingFormatted={location.pricing.COPY}
            color={false}
          />
          {location.hasColor ? (
            <PricingPanel
              pricingFormatted={location.pricing.COPY}
              color={true}
            />
          ) : null}
        </Pricing>
      ) : null}

      <PricingMessage credits={location.credits} />
    </article>
  );
};
